import { Layout } from "common/Layout";
import dynamic from "next/dynamic";
import { useEffect, useState } from "react";

const InstitutionsAboutSection = dynamic(
  () =>
    import(
      "common/Components/InstitutionsAboutSection/InstitutionsAboutSection"
    ),
  {
    ssr: false
  }
);
const InstitutionsTitelSection = dynamic(
  () =>
    import(
      "common/Components/InstitutionsTitelSection/InstitutionsTitelSection"
    ),
  {
    ssr: false
  }
);
const ProgramInclusionSection = dynamic(
  () =>
    import("common/Components/ProgramInclusionSection/ProgramInclusionSection"),
  {
    ssr: false
  }
);
const InstitutionsProgramBox = dynamic(
  () =>
    import("common/Components/InstitutionsProgramBox/InstitutionsProgramBox"),
  {
    ssr: false
  }
);

const InstitutionsBenefitsSection = dynamic(
  () =>
    import(
      "common/Components/InstitutionsBenefitsSection/InstitutionsBenefitsSection"
    ),
  {
    ssr: false
  }
);
const InstitutionsEligibleCriteriaSection = dynamic(
  () =>
    import(
      "common/Components/InstitutionsEligibleCriteriaSection/InstitutionsEligibleCriteriaSection"
    ),
  {
    ssr: false
  }
);
const InstitutionsInformationSection = dynamic(
  () =>
    import(
      "common/Components/InstitutionsInformationSection/InstitutionsInformationSection"
    ),
  {
    ssr: false
  }
);
const InstitutionsIntershipSection = dynamic(
  () =>
    import(
      "common/Components/InstitutionsIntershipSection/InstitutionsIntershipSection"
    ),
  {
    ssr: false
  }
);

const InstituteTable = dynamic(
  () => import("common/Components/InstituteTable/InstituteTable"),
  {
    ssr: false
  }
);

export const NavitasProfessional = () => {
  const [fees, setFees] = useState('');
  useEffect(() => {
    fetchData('Navitas Professional', '');
  }, [])
  const fetchData = async (institute: string, program: string) => {
    const res = await fetch(
      `${process.env.NEXT_PUBLIC_API_URL}/api/price?InstituteName=${institute}&ProgramName=${program}`
    );
    const rows = await res.json();
    setFees(rows.min ? `$${rows.min} - $${rows.max}` : '')
  };
  return (
    <>
      <InstitutionsTitelSection
        name="NAVITAS"
        tag='Professional Year'
        about="Avail Great Benefits on Enrolment for Professional Year with
                    Aussizz Group"
        image="/assets/images/navitas_big_logo.webp"
        fullname="Navitas Professional"
        aboutInstitute={[`Navitas Professional, a division of the esteemed Navitas Group, is a globally recognized educational institution. As an S&P ASX 100 company, Navitas has been instrumental in empowering over 80,000 students, both local and international, to achieve their full potential through high-quality education. With a strong legacy dating back to 1994, Navitas operates in 31 countries and employs a dedicated workforce of over 6,000 professionals. `]}
      />
      <InstitutionsAboutSection
        name="Navitas"
        tag='Navitas Professional'
        about={[`Navitas Professional, a division of the esteemed Navitas Group, is a globally recognized educational institution. As an S&P ASX 100 company, Navitas has been instrumental in empowering over 80,000 students, both local and international, to achieve their full potential through high-quality education. With a strong legacy dating back to 1994, Navitas operates in 31 countries and employs a dedicated workforce of over 6,000 professionals. `]}
        image="/assets/images/navitas_big_logo.webp"
        price={fees || "Please refer to Navitas website"}
        duration="44 weeks, inclusive 12-week internship"
        location="Adelaide, Brisbane, Canberra, Darwin, Hobart, Melbourne,
      Perth and Sydney"
        industry="Accounting ICT & Engineering"
      />
      <InstituteTable />
      <ProgramInclusionSection
        programInclusions={[
          {
            name: `32 weeks of coursework covering Australian work practice, WHS, business communications, job search skills and simulated workplace training.`,
            icon: '/assets/Icons50/calendar.webp',
          },
          {
            name: `Free professional development workshops and networking events`,
            icon: '/assets/Icons50/chair.webp',
          },
          {
            name: `12 week internship`,
            icon: '/assets/Icons50/calendar.webp',
          },
          {
            name: `The option to transfer between eight campuses*`,
            icon: '/assets/Icons50/location.webp',
          },
          {
            name: `Ongoing career counselling; before and during the program and after graduation`,
            icon: '/assets/Icons50/refer.webp',
          },
        ]}
      />
      <InstitutionsBenefitsSection
        institutionsBenefits={[
          `Assistance on developing job search portfolios and competencies`,
          `Experience of working in a simulated business
          environment`,
          `Enhanced employment opportunities`,
          `Opportunity to gain 5 migration points towards
          permanent residency`,
          `Right to access industry specific workshops and
          events for free`,
          `Option to transfer between five states:
          NSW/VIC/WA/SA/QLD`,
          `Ongoing career assistance after the completion of
          program`,
        ]}
      />
      <InstitutionsIntershipSection
        institutionsInterships={[
          {
            name: `Navitas internship companies range from ASX listed companies
            to small and medium enterprises, which provide scope of
            exclusive business networks to land the dream job.`,
            icon: '/assets/Icons50/industry.webp',
          },
          {
            name: `100% of their participants get an internship with a quality
            host company related to their field of study.`,
            icon: '/assets/Icons50/student.webp',
          },
          {
            name: `More than 83% of their interns have found employment within
            first 6 months after the completion of program.`,
            icon: '/assets/Icons50/calendar.webp',
          },
        ]}
      />
      <InstitutionsEligibleCriteriaSection eligibleCriteria={[
        `You must have completed an undergraduate or postgraduate
        course in Australia in a relevant field of study`,
        `You must have evidence of English Language Proficiency`,
        `You must applied or hold for a 
        <a class="cp-links" href="https://www.aussizzgroup.com/skilled-graduate-visa-485" target="_blank">
          Temporary Graduate Visa (Subclass 485).
        </a> 
        or Secondary Visa with work and study rights with a
        validity of at least 12 months.`,
        `You must provide a valid skills assessment from a relevant
        professional association`,

      ]} />
      <InstitutionsProgramBox />
      <InstitutionsInformationSection name='Navitas' institutionsInformations={[
          {
            name: `Avail Scholarship through us`,
            icon: '/assets/Icons50/industryv1.webp',
          },
          {
            name: `We have enriched the lives of over 20,000 successful clients`,
            icon: '/assets/Icons50/Employee-Unwind-Session.webp',
          },
          {
            name: `Reward on referring a friend`,
            icon: '/assets/Icons50/studentv1.webp',
          },
          {
            name: `One FREE consultation`,
            icon: '/assets/Icons50/system.webp',
          },
          {
            name: `Free PTE Materials `,
            icon: '/assets/Icons50/system.webp',
          },
        ]} />
    </>
  );
};

NavitasProfessional.getLayout = Layout;
NavitasProfessional.layoutOptions = {
  pageTitle: "Navitas - Professional Year Program | Australia | Aussizz Group",
  pageDescription:
    "Navitas Professional Year Program is designed to help international graduates enhance their employability skills in Australia. Join us now!",
  pageKeywords:
    "Professional Year Program,py ,Professional Year ,Navitas, Aussizz Group, Australia",
  imageUrl: "/assets/images/navitas_big_logo.webp"
};
